import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import { Query } from '../types/graphql-types';
import { SvgImage } from './Image';

export const SwedenFlag = () => {
  const data: Query = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "sweden-flag.svg" }) {
        publicURL
      }
    }
  `);

  const src = data!.file!.publicURL as string;
  return (
    <SvgImage
      title="Sweden"
      fixed={{
        height: 12,
        src,
        srcSet: src,
        width: 20
      }}
    />
  );
};
